import { render, staticRenderFns } from "./FailureAlertSettingEditor.vue?vue&type=template&id=0f60a1f6&scoped=true&lang=pug"
import script from "./FailureAlertSettingEditor.vue?vue&type=script&lang=ts"
export * from "./FailureAlertSettingEditor.vue?vue&type=script&lang=ts"
import style0 from "./FailureAlertSettingEditor.vue?vue&type=style&index=0&id=0f60a1f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f60a1f6",
  null
  
)

export default component.exports